import "./styles/about.css";
import profileImg from "../assets/profile.png";

function About() {
  return (
    <div>
      {/* HERO / TITLE */}
      <section className="about-section">
        <span className="about-label">BIOGRAPHY</span>

        <h2 className="about-headline">
          About <span>Me</span>
        </h2>
      </section>

      {/* CONTENT */}
      <section className="about">
        <div className="about-backdrop"></div>

        <div className="about-content">
          {/* HEADER */}
          <div className="about-header">
            <div className="about-photo">
              <img src={profileImg} alt="Joel George" />
            </div>

            <div className="about-intro">
              <p>
                Hey, I'm Joel — a developer who thrives at the intersection of
                performance and creativity. I love building fast, responsive web
                apps and solving technical problems with elegance.
              </p>

              <p>
                Whether I’m engineering backend systems or obsessing over
                front-end details, I care deeply about writing clean, scalable
                code that lasts.
              </p>

              <p>
                Tech I work with includes <strong>React</strong>,{" "}
                <strong>Node.js</strong>, <strong>TypeScript</strong>, and some{" "}
                <strong>LLM voodoo</strong>.
              </p>
            </div>
          </div>

          {/* SECTIONS */}
          <div className="about-sections">
            <div className="about-section glassy">
              <h3>🎯 Mission</h3>
              <p>
                To craft experiences that are functional, delightful, and
                performant — where design and engineering coexist in harmony.
              </p>
            </div>

            <div className="about-section bordered">
              <h3>🧠 Philosophy</h3>
              <p>
                I believe in simplicity, maintainability, and purpose-driven
                development. Every line of code should add clarity.
              </p>
            </div>

            <div className="about-section gradient">
              <h3>⚙️ Core Skills</h3>
              <ul>
                <li>Frontend: React, TypeScript, CSS Animations</li>
                <li>Backend: Node.js, Express, REST APIs</li>
                <li>DevOps: Docker, GitHub Actions</li>
                <li>AI: Prompt Engineering, LLM Fine-tuning</li>
              </ul>
            </div>

            <div className="about-section outline">
              <h3>🚀 Current Focus</h3>
              <p>
                Building smarter developer tools by blending traditional
                full-stack workflows with AI-driven automation.
              </p>
            </div>


            {/* PERSONAL SIGNATURE */}

            <div className="about-signature">
              
                <p className="signature-quote">
                  "Technology is at its best when it empowers people,
                  solves meaningful problems, and creates opportunities
                  that didn't exist before."
                </p>

                <div className="signature-divider" />

                <div className="signature-script">
                  Joel
                </div>

                <div className="signature-name">
                  Joel R. George
                </div>

                <div className="signature-title">
                  Software Developer • Founder, Liege Technologies
                </div>

            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default About;